'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERVAL = 3000;
var IMAGE_PATHS = [require('../assets/slideshow/1.png')];

var Slideshow = function (_React$Component) {
    _inherits(Slideshow, _React$Component);

    function Slideshow() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Slideshow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).call.apply(_ref, [this].concat(args))), _this), _this.state = { currentIndex: 0 }, _this.initiateSlideshow = function () {
            _this.interval = setInterval(function () {
                return _this.incrementIndex();
            }, INTERVAL);
        }, _this.incrementIndex = function () {
            var currentIndex = _this.state.currentIndex;

            var nextIndex = (currentIndex + 1) % IMAGE_PATHS.length;
            _this.setState({ currentIndex: nextIndex });
        }, _this.stopSlideshow = function () {
            if (_this.interval) clearInterval(_this.interval);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Slideshow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initiateSlideshow();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopSlideshow();
        }
    }, {
        key: 'render',
        value: function render() {
            var currentImagePath = IMAGE_PATHS[this.state.currentIndex];
            return _react2['default'].createElement(
                'div',
                { className: 'm-careers-page--slideshow' },
                _react2['default'].createElement('img', { src: currentImagePath })
            );
        }
    }]);

    return Slideshow;
}(_react2['default'].Component);

module.exports = Slideshow;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/careers-page/slideshow/index.jsx
 ** module id = 1561
 ** module chunks = 0
 **/